module.exports = __webpack_public_path__ + "188cb7ae.jpg";